import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { BookOpen, GoogleLogo, Sparkle } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/library";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[85vh] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-center px-14 dot-grid relative overflow-hidden">
        <div className="absolute top-16 right-16 w-24 h-24 rounded-full bg-brand-coral/20 animate-float" />
        <div className="absolute bottom-20 left-20 w-16 h-16 rounded-3xl bg-brand-sun/50 animate-float" style={{ animationDelay: "1s" }} />
        <h2 className="font-heading font-bold text-4xl text-ink tracking-tight leading-tight">Your child's cozy <span className="text-brand-sky">reading bookshelf</span> awaits.</h2>
        <p className="font-body text-ink-soft mt-4 text-lg max-w-md leading-relaxed">Sign in to unlock purchased packages, track progress, and pick up right where you left off.</p>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm bg-white sticker rounded-3xl p-8 text-center">
          <span className="grid place-items-center w-16 h-16 mx-auto rounded-3xl bg-brand-sky text-white mb-5">
            <BookOpen size={32} weight="duotone" />
          </span>
          <h1 className="font-heading font-bold text-3xl text-ink">Welcome to Reading Keeper</h1>
          <p className="font-body text-ink-soft mt-2">Sign in to access your library and checkout.</p>

          <Button onClick={handleLogin} className="w-full mt-8 rounded-full bg-brand-sky hover:bg-brand-skylight text-white font-bold text-lg py-6 transition-transform hover:-translate-y-0.5" data-testid="google-login-btn">
            <GoogleLogo size={22} weight="bold" className="mr-2" /> Continue with Google
          </Button>

          <p className="flex items-center justify-center gap-1.5 mt-6 font-body text-sm text-ink-soft">
            <Sparkle size={14} weight="fill" className="text-brand-sun" /> Fast, safe, no passwords to remember.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
